import { Component, inject, Input, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { LiveUpdateService } from "../../../../../../../../shared/src/lib/services/live-update.service";
import { Router } from "@angular/router";
import { HRowComponent } from "../../../home/sport-highlights/h-row/h-row.component";
import { TranslateModule } from "@ngx-translate/core";
import { MarketService } from "../../../../../../../../shared/src/lib/services/market.service";
import { MatIcon } from "@angular/material/icon";
import { genericSort } from "../../../../../../../../shared/src/lib/utils/market";
import { MatTooltip } from "@angular/material/tooltip";
import { Competition } from "../../../../../../../../shared/src/lib/types/market.type";

@Component({
  selector: "app-ip-market-item",
  imports: [HRowComponent, TranslateModule, MatIcon, MatTooltip],
  templateUrl: "./ip-market-item.component.html",
  styleUrl: "./ip-market-item.component.scss",
})
export class IpMarketItemComponent implements OnInit, OnDestroy {
  @Input() data: { key: string; value: any[] } = { key: "", value: [] };
  readonly destroy$ = new Subject<void>();
  isLoading: boolean = false;
  tHeaders: string[] = [];
  headerTitle = "";
  currentSport: any = "";
  liveUpdateService = inject(LiveUpdateService);
  marketService = inject(MarketService);
  parents: any[] = []; // max no of parents
  markets: any[] = [];
  currentSort: { field: string; order: "asc" | "desc" } | null = null;
  leagues: Competition[] = [];
  selectedLeague: string = "";
  marketBackup: any[] = [];

  constructor(public router: Router) {}

  ngOnInit() {
    this.markets = this.data.value;
    this.setTableHeaders(this.data.value);
    let separator = this.data.key.indexOf("_") + 1;
    this.headerTitle = this.data.key.substring(separator);
    this.currentSport = this.headerTitle.toLowerCase();
  }

  setTableHeaders(marketData: any[]) {
    const hasDraw = marketData?.some((item: any) => item?.runners?.length > 2);
    if (hasDraw) {
      this.tHeaders = ["1", "Draw", "2"];
      this.markets = marketData?.map((item: any) => {
        if (item?.runners?.length === 2) {
          const draw = { runnerName: "The Draw" };
          return { ...item, runners: [...item?.runners, draw] };
        } else {
          return item;
        }
      });
    } else {
      this.tHeaders = ["1", "2"];
    }

    this.setLeagues(this.markets);
    this.selectedLeague = "";
    this.marketBackup = this.markets;
  }

  handleSort(field: string) {
    if (!this.currentSort || this.currentSort.field !== field) {
      this.currentSort = { field, order: "asc" };
    } else if (this.currentSort.order === "asc") {
      this.currentSort.order = "desc";
    } else {
      this.currentSort = null;
    }

    const sortFields = this.currentSort ? [this.currentSort.field] : ["marketStartTime", "eventName"];

    const sortOrder = this.currentSort?.order;

    this.markets = genericSort(this.markets, sortFields, sortOrder);
  }

  setLeagues(markets: any[]) {
    const competitionMap = new Map<string, Competition>();

    for (const market of markets) {
      const comp = market.competition;
      if (comp && !competitionMap.has(comp.id)) {
        competitionMap.set(comp.id, comp);
      }
    }

    const uniqueCompetitions = Array.from(competitionMap.values());

    this.leagues = [{ id: "", name: "All Leagues" }, ...uniqueCompetitions];
  }

  handleLeagueFilter(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;
    this.selectedLeague = selectedValue;
    this.markets = selectedValue ? this.marketBackup.filter((x) => x?.competition?.id === selectedValue) : this.marketBackup;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
